import React, { useState } from 'react';

const Form = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    linkedin: '',
    telegram: '',
    query: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
  };

  const validate = () => {
    let formErrors = {};
    if (!form.name) formErrors.name = "Будь ласка, введіть своє ім'я.";
    if (!form.email)
      formErrors.email = 'Будь ласка, введіть свою електронну адресу.';
    if (!form.linkedin)
      formErrors.linkedin = 'Будь ласка, введіть свій профіль LinkedIn.';
    if (!form.telegram)
      formErrors.telegram = 'Будь ласка, введіть свій нік у Телеграм.';
    if (!form.query)
      formErrors.query = 'Будь ласка, опишіть свій запит та мету.';
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validate()) {
      return;
    }

    setIsSubmitting(true);
    setErrors({});

    try {
      const formData = new FormData();
      formData.append('access_key', '1308025e-1a6b-4942-be91-8223eebea166');
      formData.append('name', form.name);
      formData.append('email', form.email);
      formData.append('linkedin', form.linkedin);
      formData.append('telegram', form.telegram);
      formData.append('message', form.query);
      formData.append('subject', 'Нова заявка з сайту ГО Застраховано');
      formData.append('from_name', form.name);

      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData
      });

      const data = await response.json();

      if (data.success) {
        // Успішна відправка - перенаправляємо на сторінку подяки
        window.location.href = '/thank-you';
      } else {
        throw new Error(data.message || 'Помилка при відправці форми');
      }
    } catch (error) {
      console.error('Помилка відправки форми:', error);
      setErrors({
        submit: 'Виникла помилка при відправці форми. Спробуйте ще раз.'
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id='form' className='bg-white'>
      <div className='container tc'>
        <div className='s-40'></div>
        <h3 className='title-sub w-80 ma'>
          Досить мріяти, треба діяти!
        </h3>
        <p className='title-mini c-dark w-60 ma'>
          Заповни форму та надішлі нам. Це безкоштовно!
        </p>
        <div className='s-20'></div>
      </div>
      <div className='container'>
        <div className='w-60 ma'>
          <form onSubmit={handleSubmit} noValidate>
            <div className='row'>
              <div className='form-group col-lg-6 my-2'>
                <input
                  type='text'
                  className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                  id='name'
                  name='name'
                  placeholder='Як тебе звати'
                  value={form.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <div className='invalid-feedback'>{errors.name}</div>
                )}
              </div>

              <div className='form-group col-lg-6 my-2'>
                <input
                  type='email'
                  className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                  id='email'
                  name='email'
                  placeholder='Електронна адреса'
                  value={form.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <div className='invalid-feedback'>{errors.email}</div>
                )}
              </div>
            </div>

            <div className='row'>
              <div className='form-group col-lg-6 my-2'>
                <input
                  type='text'
                  className={`form-control ${errors.linkedin ? 'is-invalid' : ''}`}
                  id='linkedin'
                  name='linkedin'
                  placeholder='Профіль в LinkedIn (URL)'
                  value={form.linkedin}
                  onChange={handleChange}
                />
                {errors.linkedin && (
                  <div className='invalid-feedback'>{errors.linkedin}</div>
                )}
              </div>

              <div className='form-group col-lg-6 my-2'>
                <input
                  type='text'
                  className={`form-control ${
                    errors.telegram ? 'is-invalid' : ''
                  }`}
                  id='telegram'
                  name='telegram'
                  placeholder='@ Ник у телеграм'
                  value={form.telegram}
                  onChange={handleChange}
                />
                {errors.telegram && (
                  <div className='invalid-feedback'>{errors.telegram}</div>
                )}
              </div>
            </div>

            <div className='form-group my-2'>
              <textarea
                className={`form-control ${errors.query ? 'is-invalid' : ''}`}
                id='query'
                name='query'
                placeholder='Опиши свiй запит та мету, що ти хочеш отримати вiд пробноi консультацii'
                rows='5'
                value={form.query}
                onChange={handleChange}
              />
              {errors.query && (
                <div className='invalid-feedback'>{errors.query}</div>
              )}
            </div>
            
            {errors.submit && (
              <div className='alert alert-danger my-3' role='alert'>
                {errors.submit}
              </div>
            )}
            
            <div className='my-3'>
              <button 
                type='submit' 
                className={`button ${isSubmitting ? 'disabled' : ''}`}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Відправляємо...' : 'Записатися на тестування'}
              </button>
            </div>
            <div className='s-10'></div>

            <p className='title-mini c-dark tc'>
              А ще у нас є Telegram-канал, де регулярно виходять круті пости про
              працевлаштування в IT —{' '}
              <a href='https://t.me/+lHQh6rdzKAQ3ZjJi' target='_blank' rel="noreferrer" className='c-theme'>
                підпишись
              </a>
              , щоб стежити за ринком і бути в одному інфополі з конкурентами на
              круті вакансії та стажування
            </p>
          </form>
        </div>
      </div>
      <div className='s-100'></div>
    </section>
  );
};

export { Form };
